import { Icon, Tag, TagProps } from '@blueprintjs/core';
import styles from './SmallTag.module.css';

export const SmallTag = (props: TagProps) => {
  const { icon, className: _, children, ...tagProps } = props;
  return (
    <Tag className={styles.tag} {...tagProps}>
      <Icon icon={icon} size={10} /> {children}
    </Tag>
  );
};
